import { MouseEventHandler, ReactNode } from "react";
import style from "../style.module.scss";
import classNames from "classnames";

interface SalesOperationsCardsProps {
  title?: string | ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
  pointer?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export default function SalesOperationsCards({ title, icon, children, className, pointer, onClick }: SalesOperationsCardsProps) {
  return (
    <div onClick={onClick} className={classNames(style.details__card_container, className,  { [style.pointer]: pointer })}>
      {(title || icon) && (
        <div className="d-flex gap-2">
          {icon && <div className="flex-shrink-0">{icon}</div>}  {/* Ensure icon doesn't stretch */}
          {title && <span className={style.details__card_title}>{title}</span>}
        </div>
      )}
      {children && <div className={style.details__card_content}>{children}</div>}
    </div>
  );
}
